import moment from 'moment';

class CompensationChangeModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'CompensationChangeModal';
    $scope.step = 0;

    $scope.effectiveDate = moment($uibModalInstance.effectiveDate).toDate();
    $scope.employeeId = $uibModalInstance.employeeId;
    $scope.annualSalary = $uibModalInstance.annualSalary;
    $scope.hourlyRate = $uibModalInstance.hourlyRate;
    $scope.targetHours = $uibModalInstance.targetHours;
    $scope.employeeType = $uibModalInstance.employeeType;

    $scope.override = function() {
      $scope.method = 'override';
      $scope.step = 1;
    };

    $scope.update = function() {
      $scope.method = 'update';
      $scope.step = 1;
    };

    $scope.cancel = function () {
      $uibModalInstance.cancel();
    };

    $scope.opened = {};
    $scope.datePickerOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    $scope.datePickerFormat = 'MMM dd, yyyy';

    $scope.open = function($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.opened[elementOpened] = !$scope.opened[elementOpened];
    };


    $scope.overrideAnnualBenefit = function() {
      let obj = {}

      if($scope.employeeType != 'fullTime') {
        obj['hourlyRate'] = $scope.hourlyRate;
        obj['targetHours'] = $scope.targetHours;
      } else {
        obj['annualSalary'] = $scope.annualSalary;
      }

        $http.patch($rootScope.apiHost+"/api/admin/users/"+$scope.employeeId, obj, {withCredentials: true}).then(function (success) {
          $uibModalInstance.success();
        }, function (failure) {
          $scope.errorMessage = failure.message;
        });

    };


    $scope.updateLeaveBenefit = function() {
      let obj = {}

      obj['hourlyRate'] = $scope.hourlyRate;
      obj['targetHours'] = $scope.targetHours;
      obj['annualSalary'] = $scope.annualSalary;
      obj['effectiveDate'] = $scope.effectiveDate;
      obj['reason'] = $scope.changeReason;

      $http.patch($rootScope.apiHost+"/api/admin/users/"+$scope.employeeId+"/salary", obj, {withCredentials: true}).then(function (success) {
        $uibModalInstance.annualSalary = $scope.annualSalary;
        $uibModalInstance.effectiveDate = $scope.effectiveDate;
        $uibModalInstance.hourlyRate = $scope.hourlyRate;
        $uibModalInstance.targetHours = $scope.targetHours;

        $uibModalInstance.success();
      }, function (failure) {
        $scope.errorMessage = failure.message;
      });

    }
  }





}

export default CompensationChangeModalController;



// WEBPACK FOOTER //
// ./client/common/modals/compensationChangeModal/compensationChangeModal.controller.js